import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  '.MuiInputBase-root': {
    borderRadius: (p) => p.spacing(0.5),
  },

  '& > div ': {
    background: (p) => p.palette.common.white,
  },

  input: {
    fontSize: (p) => p.typography.caption.fontSize,
  },
  textarea: {
    fontSize: (p) => p.typography.caption.fontSize,
  },
};
